import Fuse from 'fuse.js'

const defaultOptions = {
  shouldSort: true,
  threshold: 1,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    'data.title',
    'data.name',
    'data.tags.data.name'
  ]
}

function performSearchUtil (list, query, paramsOptions = {}) {
  const options = {
    ...defaultOptions,
    ...paramsOptions
  }
  const fuse = new Fuse(list, options)
  return fuse.search(query)
}

export {
  performSearchUtil
}
